var render = function render(){var _vm=this,_c=_vm._self._c;return _c('container',{staticStyle:{"background":"#fff"}},[_c('div',{staticClass:"content"},_vm._l((_vm.imgList),function(item){return _c('img',{attrs:{"src":`data:image/jpg;base64,${item}`,"alt":""}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }